import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { siteManifest } from '@/config/site';
import { getPrimaryNavigation } from '@/config/navigation';

// Social links temporarily disabled per owner request.
// const SOCIAL_ICON: Record<string, string> = {
//   linkedin: 'fa-brands fa-linkedin-in',
//   facebook: 'fa-brands fa-facebook-f',
//   instagram: 'fa-brands fa-instagram',
// };

export default function Footer() {
  const { t, i18n } = useTranslation();
  const navItems = getPrimaryNavigation(t);
  // const socials = siteManifest.socialLinks.filter(s => s.enabled);
  const office = siteManifest.map?.office;

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <footer className="main-footer">
      <div className="container">
        <div className="row">
          {/* Brand */}
          <div className="col-lg-4 col-md-6">
            <div className="footer-links">
              <img
                src="/images/mgc-logo-footer.png"
                alt={siteManifest.brandName}
                style={{ maxWidth: '160px', marginBottom: '20px', display: 'block' }}
              />
              <p style={{ color: 'var(--accent-color)', fontWeight: 600, fontSize: '15px', marginBottom: '6px' }}>
                {t('footer.tagline')}
              </p>
              <p style={{ color: 'rgba(255,255,255,0.85)', fontWeight: 700, fontSize: '18px', marginBottom: '16px' }}>
                {t('footer.slogan')}
              </p>
              <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '14px', lineHeight: '1.6' }}>
                {t('footer.brandText')}
              </p>
              {/* Social links removed per owner request — re-enable when assets/links are finalised.
              {socials.length > 0 && (
                <div className="footer-social-links" style={{ marginTop: '18px', display: 'flex', gap: '12px' }}>
                  {socials.map(s => (
                    <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label}>
                      <i className={SOCIAL_ICON[s.label.toLowerCase()] || 'fa-solid fa-link'} aria-hidden="true" />
                    </a>
                  ))}
                </div>
              )}
              */}
            </div>
          </div>

          {/* Navigation */}
          <div className="col-lg-4 col-md-6">
            <div className="footer-links">
              <h3>{t('footer.navigation')}</h3>
              <ul>
                {navItems.map(item => (
                  <li key={item.to}><Link to={item.to}>{item.label}</Link></li>
                ))}
              </ul>
            </div>
          </div>

          {/* Contact */}
          <div className="col-lg-4 col-md-6">
            <div className="footer-contact-box footer-links">
              <h3>{t('footer.contactUs')}</h3>
              <div className="footer-contact-item">
                <div className="icon-box"><i className="fa-solid fa-phone"></i></div>
                <div className="footer-contact-content"><p>{siteManifest.contact.phone}</p></div>
              </div>
              <div className="footer-contact-item">
                <div className="icon-box"><i className="fa-solid fa-envelope"></i></div>
                <div className="footer-contact-content"><p>{siteManifest.contact.email}</p></div>
              </div>
              <div className="footer-contact-item">
                <div className="icon-box"><i className="fa-solid fa-location-dot"></i></div>
                <div className="footer-contact-content">
                  <p>{office?.addressLine1}, {office?.addressLine2}</p>
                </div>
              </div>

              {/* Language Switcher */}
              <div className="language-switcher">
                <p className="language-switcher-label">{t('footer.language')}</p>
                <div className="language-switcher-buttons">
                  <button
                    className={`lang-btn ${i18n.language === 'en' ? 'active' : ''}`}
                    onClick={() => changeLanguage('en')}
                    type="button"
                  >
                    {t('footer.english')}
                  </button>
                  <button
                    className={`lang-btn ${i18n.language === 'zh' ? 'active' : ''}`}
                    onClick={() => changeLanguage('zh')}
                    type="button"
                  >
                    {t('footer.chinese')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Copyright */}
        <div className="footer-copyright">
          <div className="row">
            <div className="col-md-12">
              <div className="footer-copyright-text">
                <p>{siteManifest.footer.copyright} &nbsp;|&nbsp; {siteManifest.footer.credit}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
